import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import useFetch from 'hooks/useFetch';
import { FETCH_VEHICLES } from '../actions';
export const initialState = {
    loading: false,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    error: ''
};

export const fetchVehicles = createAsyncThunk(FETCH_VEHICLES, (url) => {
    return url ? useFetch(url, false) : useFetch('vehicles');
});

const vehiclesSlice = createSlice({
    name: 'vehicles',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchVehicles.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(fetchVehicles.fulfilled, (state, action) => {
            state.loading = false;
            state.data.count = action.payload.data.count;
            state.data.next = action.payload.data.next;
            state.data.previous = action.payload.data.previous;
            state.data.results = state.data.results.concat(action.payload.data.results);
            state.error = '';
        });

        builder.addCase(fetchVehicles.rejected, (state, action) => {
            state.loading = false;
            state.data.results = [];
            state.error = action.error.message;
        });
    }
});

export default vehiclesSlice;
